import { useController, useFormContext, type FieldValues, type Path } from "react-hook-form";
import CustomInputWithUnit from "../CustomInputWithUnit/CustomInputWithUnit";
import { useVariantFieldDisabled } from "./context/VariantFieldContext";

export interface FormInputWithUnitProps<TFieldValues extends FieldValues = FieldValues> {
    name: Path<TFieldValues> | (string & NonNullable<unknown>);
    label?: string;
    unitSuffix?: string;
    placeholder?: string;
    helpText?: string;
    toolTip?: string;
    min?: number;
    disabled?: boolean;
}

export function FormInputWithUnit<TFieldValues extends FieldValues = FieldValues>({
    name,
    label,
    unitSuffix,
    placeholder,
    helpText,
    toolTip,
    min = 0,
    disabled = false,
}: FormInputWithUnitProps<TFieldValues>) {
    const { control } = useFormContext<TFieldValues>();
    const {
        field,
        fieldState: { error },
    } = useController<TFieldValues>({ control, name: name as any });

    const isAbDisabled = useVariantFieldDisabled(name as string);

    return (
        <CustomInputWithUnit
            label={label}
            unitSuffix={unitSuffix}
            placeholder={placeholder}
            helpText={helpText}
            toolTip={toolTip}
            min={min}
            setValue={(val) => field.onChange(val === "" ? 0 : Number(val))}
            value={field.value !== undefined && field.value !== null ? Number(field.value) : ""}
            error={error?.message}
            props={{
                ...field,
                disabled: disabled || isAbDisabled,
            }}
        />
    );
}
